import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import { Button } from '../../../elements/controls'
import { ResponsiveImage } from '../../../elements/images/ResponsiveImage/ResponsiveImage'
import { H2 } from '../../../elements/typography'
import { media, useMediaSelect } from '../../../style/media'
import { FilmCarousel } from '../../content/FilmCarousel/FilmCarousel'
import { PlanBenefits } from '../../subscriptions'
import messages from '../messages'
import { QuoteCarousel } from './QuoteCarousel'

const Container = styled(View)`
  align-items: stretch;
  ${media.sm`
    align-items: center;
  `};
  ${media.lg`
    max-width: 1200px;
    margin: 0 auto;
  `};
`

const Section = styled(View)`
  margin-bottom: ${(props) => props.theme.spacing.large}px;
  padding: 0 ${(props) => props.theme.spacing.medium}px;
  max-width: 100%;
  width: 100%;
  ${media.sm`
    margin-bottom: ${(props) => props.theme.spacing.xlarge}px;
    padding: 0 ${(props) => props.theme.spacing.larger}px;
    max-width: ${(props) => props.maxWidth || '100%'};
  `};
`

const BenefitsSection = styled(Section)`
  max-width: 440px;
  align-self: center;
`

const NewsSection = styled(Section)`
  ${media.sm`max-width: 65%;`};
  ${media.lg`max-width: 100%;`};
`

const FilmsSection = styled(Section)`
  padding: 0;
`

const LaurelsSection = styled(Section)`
  ${media.sm`max-width: 80%;`};
`

const Heading = styled(H2)`
  text-align: center;
  font-size: ${(props) => props.theme.fontSizes.xlarge}px;
  margin-bottom: ${(props) => props.theme.spacing[props.margin ?? 'medium']}px;
  ${media.sm`
    margin-bottom: ${(props) => props.theme.spacing[props.margin ?? 'larger']}px;
  `};
  ${media.md`
    font-size: ${(props) => props.theme.fontSizes.xlarge + 4}px;
  `};
`

export const RegisterAccountPromos = ({ chosenPlan, monthlyPlan, onSignUpPress, films }) => {
  const laurelsImage = useMediaSelect({
    md: { aspectRatio: 3.699, maxHeight: 519, publicId: 'web/landing-page/Laurels' },
    xs: {
      aspectRatio: 1.596,
      maxHeight: 470,
      publicId: 'web/landing-page/LaurelsMobile',
    },
  })
  return (
    <Container>
      <BenefitsSection>
        <Heading>
          <FormattedMessage {...messages.promoBenefits} />
        </Heading>
        <PlanBenefits chosenPlan={chosenPlan} monthlyPlan={monthlyPlan} />
      </BenefitsSection>

      <NewsSection>
        <Heading>
          <FormattedMessage {...messages.promoFeaturedIn} />
        </Heading>
        <ResponsiveImage publicId="web/press/press-logos" aspectRatio={4.261} maxHeight={176} />
      </NewsSection>

      <FilmsSection>
        <Heading>
          <FormattedMessage {...messages.promoInstantAccess} />
        </Heading>
        <FilmCarousel items={films} />
      </FilmsSection>

      <LaurelsSection>
        <ResponsiveImage {...laurelsImage} resizeMode="contain" />
      </LaurelsSection>

      <Section maxWidth="380px">
        <Heading margin="large">
          <FormattedMessage {...messages.promoSayingAbout} />
        </Heading>
        <QuoteCarousel />
      </Section>

      <Section>
        <Button
          variant="primary"
          alignSelf="center"
          onPress={onSignUpPress}
          intlMsg={chosenPlan?.hasFreeTrial ? messages.btnSignUpFree : messages.btnSignUpPaid}
        />
      </Section>
    </Container>
  )
}
